import React, { Component } from 'react';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import { Cascader, Input, Button, Select, DatePicker, Modal, message } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new';
import ExportUtil from '../../../common/ExportUtil';
import moment from 'moment';

const Option = Select.Option;
const { MonthPicker, RangePicker } = DatePicker;

class Filter extends Component {

    state = {
        researchProductTypeList: [],
        byStageList: [],
        businessList: [],
        areaList: [],
        typeList: [],
        BusinessOpportunityList: [],
        exportModalVisible: false,
        exportYearMonth: null,
    }

    componentDidMount(){
        this.queryConfigWithChildByType();
        this.queryBusiness();
        this.loadTypeConfigureList();
        this.queryBasicConfigureByType();
    }

    //研究产品类型选项
    queryConfigWithChildByType = () => {
        dictCache.getDict('CONFIG_WITH_CHILD_RESEARCH_PRODUCT_TYPE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.evaluate.queryConfigWithChildByType,
                data: { type: 'RESEARCH_PRODUCT_TYPE' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { list = [] } = res;
            const newList = list.map(el => ({
                value: el.evaluateConfigureId,
                code: el.code,
                label: el.configureValue,
                children: el.childList.length ? el.childList.map(childData => ({
                    value: childData.evaluateConfigureId,
                    label: childData.configureValue,
                })) : undefined,
            }));
            this.setState({ researchProductTypeList: newList });
        });
    }

    //临床分期选项
    loadByStageList = (researchProductTypeId) => {
        const { researchProductTypeList } = this.state;
        let investigationMedicineType = '';
        researchProductTypeList.map(el => {
            if (el.value == researchProductTypeId[0]) {
                investigationMedicineType = el.code;
            }
        });
        if (investigationMedicineType) {
            const options = {
                method: 'POST',
                url: API_URL.common.queryInvestigationByStageByMedicine,
                data: { investigationMedicineType },
                dataType: 'json',
                doneResult: res => {
                    this.setState({ byStageList: res.data });
                }
            }
            $.sendRequest(options);
        } else {
            this.setState({ byStageList: [] });
        }
    }

    //获取业务线选项
    queryBusiness = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => this.setState({ businessList: res.typeConfigureList || [] }));
    }

    //获取项目领域、项目分类选项
    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.typeConfigureList,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({
                areaList: res.areaList,
                typeList: res.typeList,
            });
        });
    }

   //业务机会状态查询
    queryBasicConfigureByType = () => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryBasicConfigureByType,
            data: { type: 'BusinessOpportunity' },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    BusinessOpportunityList: res.datas,
                });
            }
        }
        $.sendRequest(options)
    }

    handleChange = (value, key) => {
        const { params } = this.props;
        params[key] = value;
        switch (key) {
            case 'researchProductTypeId':
                params.byStageId = undefined;
                this.loadByStageList(value);
                break;
            case 'investigationAreaId':
                params.diseaseId = undefined;
                break;
            case 'awardDate':
            case 'jdeActualSignDate': {
                const [start, end] = value;
                params[`${key}Begin`] = start;
                params[`${key}End`] = end;
                break;
            }
        }
        this.props.onChange(params, key);
    }

    searchRetrieveChange = (option, key) => {
        const { params } = this.props;
        params[`${key}Id`] = option.value;
        params[`${key}Name`] = option.text;
        this.props.onChange(params, key);
    }

    reset = () => {
        this.props.onChange({researchProductTypeId: undefined});
        this.props.search();
    }

    disabledDate = (current, key) => {
        const { params: { beginYearMonthStr, endYearMonthStr } } = this.props;
        return key === 'endYearMonthStr'? current < moment(beginYearMonthStr) : current > moment(endYearMonthStr);
    }

    showExportModal = () => {
        this.setState({
            exportModalVisible: true,
            exportYearMonth: moment(),
        });
    }

    hideExportModal = () => {
        this.setState({
            exportModalVisible: false,
            exportYearMonth: null,
        });
    }

    handleExportMonthChange = (date) => {
        this.setState({ exportYearMonth: date });
    }

    exportGpData = () => {
        const { exportYearMonth } = this.state;
        if (!exportYearMonth) {
            return;
        }
        const options = {
            method: 'POST',
            url: API_URL.evaluate.exportQuotationGpDataList,
            data: { recordYearMonth: Number(exportYearMonth.format('YYYYMM')) },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success || '导出成功');
                this.hideExportModal();
            },
        };
        $.sendRequest(options);
    }

    disabledFutureMonth = (current) => {
        return current >= moment().startOf('month');
    }

    render() {
        const { params, search, dataExport, historyStatus, isSeniorUserBo, isLineDeptBO, isGpFinSet, isLineCharge } = this.props;
        const { 
            beginYearMonthStr,
            endYearMonthStr,
            evaluateCode,
            investigationName,
            businessOpportunityNum,
            pmUserName,
            talUserName,
            bdUserName,
            baUserName,
            evaluateSerialNumber,
            sponsorCompanyName,
            contractSignName,
            researchProductTypeId,
            byStageId,
            investigationAreaId,
            diseaseName,
            lineOfBusinessId,
            invTypeId,
            quotationType,
            evaluateStatus,
            businessOpportunityStatusShow,
            awardDateBegin,
            awardDateEnd,
            jdeActualSignDateBegin,
            jdeActualSignDateEnd,
        } = params;
        const { researchProductTypeList, byStageList, businessList, areaList, typeList, BusinessOpportunityList, exportModalVisible, exportYearMonth } = this.state;
        const byStageOption = byStageList.map(el => <Option value={el.investigationByStageId}>{el.investigationByStageName}</Option>); //临床分期
        const businessOption = businessList.filter(el => el.groupId == 1).map(el => <Option value={el.typeConfigureId}>{el.typeValue}</Option>);  //业务线
        const areaOption = areaList.map(el => <Option value={el.investigationAreaId}>{el.investigationAreaName}</Option>); //治疗领域
        const typeOption = typeList.map(el => <Option value={el.typeConfigureId}>{el.typeValue}</Option>);  //项目分类
        const BusinessOpportunityOption = BusinessOpportunityList.map(el => <Option value={el.configureValue} title={el.configureValueCn || el.configureValue}>{el.configureValueCn || el.configureValue}</Option>);  //业务机会状态（显示中文configureValueCn，查询传值仍为configureValue）
        const awardDate = [
            awardDateBegin ? moment(awardDateBegin) : null,
            awardDateEnd ? moment(awardDateEnd) : null,
        ];
        const jdeActualSignDate = [
            jdeActualSignDateBegin ? moment(jdeActualSignDateBegin) : null,
            jdeActualSignDateEnd ? moment(jdeActualSignDateEnd) : null,
        ];
        // 判断是否显示导出按钮
        const showExportBtn = historyStatus !== 'GP' || 
            (isSeniorUserBo || isLineDeptBO || isGpFinSet || isLineCharge);
        
        return (
            <div className="search-bar" style={{ marginBottom: 10 }}>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">时间</label>
                    <MonthPicker
                        className="begin"
                        format={'YYYY-MM'}
                        value={beginYearMonthStr ? moment(beginYearMonthStr) : null}
                        allowClear={false}
                        placeholder="开始月份"
                        style={{ width: 90 }}
                        disabledDate={(current) => this.disabledDate(current, 'beginYearMonthStr')}
                        onChange={(date, dateString) => this.handleChange(dateString, 'beginYearMonthStr')}
                    />
                    <span style={{ margin: '3px 6px' }}>~</span>
                    <MonthPicker
                        className="end"
                        format={'YYYY-MM'}
                        value={endYearMonthStr ? moment(endYearMonthStr) : null}
                        allowClear={false}
                        placeholder="结束月份"
                        style={{ width: 90 }}
                        disabledDate={(current) => this.disabledDate(current, 'endYearMonthStr')}
                        onChange={(date, dateString) => this.handleChange(dateString, 'endYearMonthStr')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">临床评估单号</label>
                    <Input
                        style={{ width: 120 }}
                        placeholder="请输入"
                        value={evaluateCode}
                        onChange={e => this.handleChange(e.target.value, 'evaluateCode')}
                    />
                </div>
                {historyStatus != 'GP' && (<div className="search-item">
                    <label htmlFor="" className="ui-label">项目简称</label>
                    <SearchRetrieve
                        keyword='investigationName'
                        style={{width: 160}}
                        placeholder='输入名称检索'
                        params={{limit: 20}}
                        url={API_URL.investigation.queryInvestigationByName}
                        config={{ id: 'investigationId', name: 'investigationName'}}
                        value={investigationName}
                        onChange={value => this.searchRetrieveChange(value, 'investigation')}
                    />
                </div>)}
                <div className="search-item">
                    <label htmlFor="" className="ui-label">业务机会编号</label>
                    <Input
                        style={{ width: 120 }}
                        placeholder="请输入"
                        value={businessOpportunityNum}
                        onChange={e => this.handleChange(e.target.value, 'businessOpportunityNum')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">PM</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{width: 160}}
                        placeholder='输入名称检索'
                        params={{limit: 20}}
                        url={API_URL.investigation.queryUserByKey}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user'}}
                        value={pmUserName}
                        onChange={value => this.searchRetrieveChange(value, 'pmUser')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">领域leader</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{width: 160}}
                        placeholder='输入名称检索'
                        params={{limit: 20}}
                        url={API_URL.user.queryLeaderList}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user'}}
                        value={talUserName}
                        onChange={value => this.searchRetrieveChange(value, 'talUser')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">BD</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{width: 160}}
                        placeholder='输入名称检索'
                        params={{limit: 20}}
                        url={API_URL.investigation.queryUserByKey}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user'}}
                        value={bdUserName}
                        onChange={value => this.searchRetrieveChange(value, 'bdUser')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">BA</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{width: 160}}
                        placeholder='输入名称检索'
                        params={{limit: 20}}
                        url={API_URL.investigation.queryUserByKey}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user'}}
                        value={baUserName}
                        onChange={value => this.searchRetrieveChange(value, 'baUser')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">方案编号</label>
                    <Input
                        style={{ width: 120 }}
                        placeholder="请输入"
                        value={evaluateSerialNumber}
                        onChange={e => this.handleChange(e.target.value, 'evaluateSerialNumber')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">合同签署方</label>
                    <SearchRetrieve
                        keyword='customerCompanyName'
                        style={{width: 160}}
                        placeholder='输入名称检索'
                        params={{limit: 20}}
                        url={API_URL.investigation.queryCustomerCompanyByName}
                        config={{ id: 'customerCompanyId', name: 'customerCompanyName'}}
                        value={contractSignName}
                        onChange={value => this.searchRetrieveChange(value, 'contractSign')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">申办方</label>
                    <SearchRetrieve
                        keyword='customerCompanyName'
                        style={{width: 160}}
                        placeholder='输入名称检索'
                        params={{limit: 20, natureName: '申办方'}}
                        url={API_URL.investigation.queryCustomerCompanyByName}
                        config={{ id: 'customerCompanyId', name: 'customerCompanyName'}}
                        value={sponsorCompanyName}
                        onChange={value => this.searchRetrieveChange(value, 'sponsorCompany')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">研究产品类型</label>
                    <Cascader
                        style={{ width: 120 }}
                        allowClear
                        placeholder="请选择"
                        options={researchProductTypeList}
                        value={researchProductTypeId}
                        onChange={value => this.handleChange(value, 'researchProductTypeId')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">临床分期</label>
                    <Select
                        style={{width: 120}}
                        allowClear
                        placeholder='请选择'
                        value={byStageId}
                        onChange={value => this.handleChange(value, 'byStageId')}
                    >
                        {byStageOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">治疗领域</label>
                    <Select
                        style={{width: 160}}
                        placeholder='输入名称检索'
                        allowClear
                        showSearch
                        filterOption= {(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        value={investigationAreaId}
                        onChange={value => this.handleChange(value, 'investigationAreaId')}
                    >
                        {areaOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">适应症</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{width: 160}}
                        placeholder='输入名称检索'
                        params={{limit: 20, investigationAreaId: investigationAreaId ? investigationAreaId : undefined}}
                        url={API_URL.common.queryAllDisease}
                        config={{ id: 'diseaseId', name: 'diseaseName'}}
                        value={diseaseName}
                        onChange={value => this.searchRetrieveChange(value, 'disease')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">业务线</label>
                    <Select
                        style={{width: 120}}
                        allowClear
                        placeholder='请选择'
                        value={lineOfBusinessId}
                        onChange={value => this.handleChange(value, 'lineOfBusinessId')}
                    >
                        {businessOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">项目分类</label>
                    <Select
                        style={{width: 120}}
                        allowClear
                        placeholder='请选择'
                        value={invTypeId}
                        onChange={value => this.handleChange(value, 'invTypeId')}
                    >
                        {typeOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">报价方式</label>
                    <Select
                        style={{width: 120}}
                        allowClear
                        placeholder='请选择'
                        value={quotationType}
                        onChange={value => this.handleChange(value, 'quotationType')}
                    >
                        <Option value={'VISIT_QUOTATION'}>{'访视评估'}</Option>
                        <Option value={'FTE_QUOTATION'}>{'一口价（建议评估）'}</Option>
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">报价状态</label>
                    <Select
                        style={{width: 180}}
                        allowClear
                        placeholder='请选择'
                        value={evaluateStatus}
                        onChange={value => this.handleChange(value, 'evaluateStatus')}
                    >
                        <Option value={'NEW_EVALUATE'}>{'待PM评估'}</Option>
                        <Option value={'CLINICAL_RETURN_EVALUATION'}>{'临床退回评估单'}</Option>
                        <Option value={'CLINICAL_NON_ACCEPTANCE_EVALUATION'}>{'临床不承接评估单'}</Option>
                        <Option value={'CONFIRM'}>{'PM确认评估单'}</Option>
                        <Option value={'REFUSE'}>{'领域leader/BO拒绝评估单'}</Option>
                        <Option value={'SUBMIT'}>{'领域leader/BO提交评估单'}</Option>
                        <Option value={'REPULSE'}>{'商务反馈评估建议'}</Option>
                        <Option value={'STATE_FOR_APPROVAL'}>{'总价审批中'}</Option>
                        <Option value={'STATE_FOR_RESTART_APPROVAL'}>{'总价重新申请中'}</Option>
                        <Option value={'STATE_APPROVAL_REFUSED'}>{'总价审批不通过'}</Option>
                        <Option value={'STATE_APPROVED'}>{'总价审批已通过'}</Option>
                        <Option value={'STATE_CONFIRM'}>{'总价已确认'}</Option>
                        <Option value={'STATE_PUBLISHED'}>{'报价已发布'}</Option>
                        <Option value={'STATE_PUBLISHED_REEVALUATE_CONFIRM'}>{'报价已发布（待二次评估确认）'}</Option>
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">业务机会状态</label>
                    <Select
                        style={{width: 160}}
                        allowClear
                        placeholder='请选择'
                        value={businessOpportunityStatusShow}
                        onChange={value => this.handleChange(value, 'businessOpportunityStatusShow')}
                    >
                        {BusinessOpportunityOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">获标日期</label>
                    <RangePicker
                        placeholder={["开始日期", "结束日期"]}
                        style={{width: 200}}
                        format={'YYYY-MM-DD'}
                        value={awardDate}
                        onChange={(dates, dateStrings) => this.handleChange(dateStrings, 'awardDate')}
                    />
                </div>
                {
                    historyStatus == 'GP' && (<div className="search-item">
                        <label htmlFor="" className="ui-label">合同签署日期</label>
                        <RangePicker
                            placeholder={["开始日期", "结束日期"]}
                            style={{width: 200}}
                            format={'YYYY-MM-DD'}
                            value={jdeActualSignDate}
                            onChange={(dates, dateStrings) => this.handleChange(dateStrings, 'jdeActualSignDate')}
                        />
                    </div>)
                }
                <div className="search-item">
                    <Button key="search" type="primary" onClick={search}>搜索</Button>
                    {showExportBtn && <Button key="export" type="primary" onClick={dataExport}>导出</Button>}
                    {historyStatus == 'GP' && isGpFinSet && <Button key="exportCure" type="primary" onClick={this.showExportModal}>导出固化数据</Button>}
                    <Button key="reset" type="primary" onClick={this.reset}>重置</Button>
                </div>
                <Modal
                    title="导出固化数据"
                    visible={exportModalVisible}
                    onCancel={this.hideExportModal}
                    onOk={this.exportGpData}
                    maskClosable={false}
                    width={500}
                >
                    <div style={{ padding: '30px 20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <span style={{ whiteSpace: 'nowrap' }}>请选择固化月份：</span>
                        <MonthPicker
                            placeholder='请选择'
                            disabledDate={this.disabledFutureMonth}
                            value={exportYearMonth}
                            onChange={this.handleExportMonthChange}
                        />
                    </div>
                </Modal>
            </div>
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/Filter.js